export default __webpack_public_path__ + "maps-examples-multiple-shapes-thumbnail-960-653433c845cc672cb1719655907e4d9f.webp";